import React, { useState, useRef } from 'react';
import { supabase } from './data/supabaseClient';
import { CustomButton4 } from './Templates';
import googleColorsImage from './Media/googlecolors.jpg';
import { useTranslation } from 'react-i18next';
import Spinner from './common/Spinner';
import './GoogleSignInButton.css';

function GoogleSignInButton() {
  const { t } = useTranslation('common');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const errorTimerRef = useRef(null);

  async function handleGoogleSignIn() {
    try {
      // Clear any existing timers
      if (errorTimerRef.current) {
        clearTimeout(errorTimerRef.current);
        errorTimerRef.current = null;
      }
      
      setIsLoading(true);
      setError(null);
      
      // Initiate Google OAuth sign-in
      const { error: signInError } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${process.env.REACT_APP_SITE_URL || window.location.origin}/complete-profile`
        }
      });

      if (signInError) {
        console.error("Google login error:", signInError.message);
        // Set error after a delay to avoid flashing messages for temporary issues
        errorTimerRef.current = setTimeout(() => {
          setError(t('auth.google_sign_in_error') || "Failed to sign in with Google");
          setIsLoading(false);
        }, 1500);
        return;
      }

      // No need to wait for user data here - the OAuth flow will redirect
      // Let the loading state persist until redirect happens
      
    } catch (error) {
      console.error("Unexpected error during Google login:", error.message);
      
      // Set error after a delay
      errorTimerRef.current = setTimeout(() => {
        setError(t('auth.unexpected_error') || "An unexpected error occurred");
        setIsLoading(false);
      }, 1500);
    }
  }

  // Clean up timer on unmount
  React.useEffect(() => {
    return () => {
      if (errorTimerRef.current) {
        clearTimeout(errorTimerRef.current);
      }
    };
  }, []);

  return (
    <div className="google-sign-in-container">
      {error && <div className="auth-error">{error}</div>}
      
      <CustomButton4
        label={isLoading ? t('auth.signing_in') : t('auth.sign_in_with_google')}
        onClick={handleGoogleSignIn}
        backgroundImage={googleColorsImage}
        disabled={isLoading}
        className={isLoading ? "loading" : ""}
      >
        {isLoading && (
          <Spinner 
            size="small" 
            showText={false} 
            thickness={2}
            color="var(--BackG-color)"
          />
        )}
      </CustomButton4>
    </div>
  );
}

export default GoogleSignInButton;